<template>
    <div id="kanban-list">
        <div class="kanban-task-table">
            <a-table :columns="columns" :data-source="tasks" :pagination="false">
                <span slot="pipelineStage" slot-scope="pipelineStage, data">
                    <div class="supsis-tag-el" :style="{ '--pipeline-color': data.pipelineStage.color }">
                        {{ data.pipelineStage.name }}
                    </div>
                </span>
                <span slot="owner" slot-scope="owner, data">
                    <div class="agent-detail">
                        <Avatar
                            v-if="owner"
                            :size="25"
                            :key="owner"
                            :src="users[owner].gravatar"
                            :username="users[owner].name"
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="users[owner].name"
                        />
                        <div
                            v-if="users[owner]"
                            v-tippy="{content: users[owner].name}"
                        >
                            {{ users[owner].name.substring(0, 8) + "..." }}
                        </div>
                    </div>
                </span>
                <span slot="assignees" slot-scope="assignees, data">
                    <div class="agent-detail">
                        <Avatar
                            v-if="users[assignees[0]]"
                            :size="25"
                            :key="assignees[0]"
                            :src="users[assignees[0]].gravatar"
                            :username="users[assignees[0]].name"
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                            }"
                            :content="users[assignees[0]].email"
                        />
                        <div
                            v-if="users[assignees[0]]"
                            v-tippy="{content: users[assignees[0]].name}"
                        >
                            {{ users[assignees[0]].name.substring(0, 8) + "..." }}
                        </div>
                    </div>
                </span>
                <span slot="createdAt" slot-scope="createdAt"> {{ formatDate(createdAt) }} </span>
                <span slot="startDate" slot-scope="startDate"> {{ formatDate(startDate) }} </span>
                <span slot="endDate" slot-scope="endDate">{{ formatDate(endDate) }} </span>
            </a-table>
            <div class="paginator">
                <a-pagination
                    v-model="page"
                    :page-size.sync="perPage"
                    :pageSizeOptions="[5, 10, 20, 50, 100]"
                    show-size-changer
                    :total="totalCount"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Avatar from "vue-avatar";
import { getOrUpdateFilters } from "../../utils/persistenceStorage";
import moment from "moment";

const filters = getOrUpdateFilters("kanbanlist");
export default {
    name: "KanbanList",
    components: {
        Avatar,
    },
    props: {
        visitorId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            page: filters.page || 1,
            perPage: filters.perPage || 20,
            columns: [
                {
                    title: this.$t('message.createdDate'),
                    dataIndex: "createdAt",
                    width: "25%",
                    scopedSlots: { customRender: "createdAt" },
                },
                {
                    title: this.$t('message.name'),
                    dataIndex: "title",
                    width: "25%",
                },
                {
                    title: this.$t('task.stage'),
                    dataIndex: "pipelineStage",
                    width: "15%",
                    scopedSlots: { customRender: "pipelineStage" },
                },
                {
                    title: this.$t('task.owner'),
                    dataIndex: "owner",
                    scopedSlots: { customRender: "owner" },
                },
                {
                    title: this.$t('task.assignees'),
                    dataIndex: "assignees",
                    scopedSlots: { customRender: "assignees" },
                },
                {
                    title: this.$t('message.startDate'),
                    dataIndex: "startDate",
                    scopedSlots: { customRender: "startDate" },
                },
                {
                    title: this.$t('message.endDate'),
                    dataIndex: "startDate",
                    scopedSlots: { customRender: "endDate" },
                },
            ],
            tasks: [],
            totalCount: [],
        };
    },
    computed: {
        ...mapState({
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
        }),
    },
    methods: {
        ...mapActions({
            getListTasks: "tasks/getListTasks",
        }),
        formatDate(date) {
            return date && this.$moment(date).format("YYYY/MM/DD HH:mm");
        },
        getTasks() {
            getOrUpdateFilters("kanbanlist", {
                page: this.page,
                perPage: this.perPage,
            });
            this.getListTasks({
                page: this.page,
                perPage: this.perPage,
                visitorId: this.visitorId,
            }).then(({ data, total }) => {
                this.tasks = data;
                this.totalCount = total;
            });
        },
    },
    mounted() {
        this.getTasks();
    },
    watch: {
        page() {
            this.getTasks();
        },
        perPage() {
            this.getTasks();
        },
    },
};
</script>
<style lang="scss">
#kanban-list {
    .kanban-task-search {
        display: flex;
        justify-content: center;
        margin-top: 9px;
    }

    .kanban-task-table {
        background-color: #eef0f8;
        padding: 20px;
    }

    .ant-table-tbody {
        background: #fff;
    }
    .ant-table-thead > tr > th {
        background: #fff;
    }
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
        background-color: #ffded5;
    }
    .supsis-tag-el {
        padding: 4px 10px;
        border: 1px solid var(--pipeline-color);
        color: var(--pipeline-color);
        border-radius: 100px;
        width: max-content;
    }
    .agent-detail {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .paginator {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: end;
    }
}
</style>
